// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentPostmanRequestModel {
    static getAttributeTypeMap() {
        return EnrollmentPostmanRequestModel.attributeTypeMap;
    }
}
EnrollmentPostmanRequestModel.discriminator = undefined;
EnrollmentPostmanRequestModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "string"
    },
    {
        "name": "headers",
        "baseName": "headers",
        "type": "string"
    },
    {
        "name": "url",
        "baseName": "url",
        "type": "string"
    },
    {
        "name": "pathVariables",
        "baseName": "pathVariables",
        "type": "{ [key: string]: string; }"
    },
    {
        "name": "method",
        "baseName": "method",
        "type": "string"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<EnrollmentPostmanDataModel>"
    },
    {
        "name": "dataMode",
        "baseName": "dataMode",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
    {
        "name": "descriptionFormat",
        "baseName": "descriptionFormat",
        "type": "string"
    },
    {
        "name": "time",
        "baseName": "time",
        "type": "number"
    },
    {
        "name": "version",
        "baseName": "version",
        "type": "number"
    },
    {
        "name": "responses",
        "baseName": "responses",
        "type": "Array<string>"
    },
    {
        "name": "collectionId",
        "baseName": "collectionId",
        "type": "string"
    },
    {
        "name": "folder",
        "baseName": "folder",
        "type": "string"
    },
    {
        "name": "tests",
        "baseName": "tests",
        "type": "string"
    },
    {
        "name": "preRequestScript",
        "baseName": "preRequestScript",
        "type": "string"
    },
    {
        "name": "rawModeData",
        "baseName": "rawModeData",
        "type": "string"
    }
];
//# sourceMappingURL=enrollmentPostmanRequestModel.js.map